// extracted by mini-css-extract-plugin
export var actionIcon = "_si-0";